module.exports = __webpack_public_path__ + "img/js-planewar.0b840720.png";